import { render, staticRenderFns } from "./selectStaffsDiv.vue?vue&type=template&id=4b5d4204&scoped=true"
import script from "./selectStaffsDiv.vue?vue&type=script&lang=js"
export * from "./selectStaffsDiv.vue?vue&type=script&lang=js"
import style0 from "./selectStaffsDiv.vue?vue&type=style&index=0&id=4b5d4204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d4204",
  null
  
)

export default component.exports